export var createNumberArray = function (start, end) {
    if (start === void 0) { start = 0; }
    var bigNumber = Math.max(start, end);
    var smallNumber = Math.min(start, end);
    return Array.apply(null, Array(bigNumber - smallNumber + 1)).map(function (_, i) { return start + (start > end ? -i : i); });
};
